import { useIntl } from "react-intl";
import { Button } from "@/components/design/Button";

export function AccessManagementPanel({ onOpenRoles }: { onOpenRoles: () => void }) {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id });

  return (
    <section aria-labelledby="access-management-title" className="space-y-6">
      <div className="box bg-surface p-6">
        <h2 id="access-management-title" className="text-xl font-medium text-ink">
          {t("settings.sectionAccessManagement")}
        </h2>
        <p className="mt-3 max-w-3xl text-sm leading-relaxed text-ink/70">{t("admin.access.intro")}</p>
        <dl className="mt-6 grid grid-cols-1 gap-6 border-t border-ink/10 pt-6 xl:grid-cols-3">
          <div>
            <dt className="text-sm font-medium">{t("admin.access.permissionTitle")}</dt>
            <dd className="mt-2 text-sm leading-relaxed text-ink/70">{t("admin.access.permissionBody")}</dd>
          </div>
          <div>
            <dt className="text-sm font-medium">{t("admin.access.roleTitle")}</dt>
            <dd className="mt-2 text-sm leading-relaxed text-ink/70">{t("admin.access.roleBody")}</dd>
          </div>
          <div>
            <dt className="text-sm font-medium">{t("admin.access.assignmentTitle")}</dt>
            <dd className="mt-2 text-sm leading-relaxed text-ink/70">{t("admin.access.assignmentBody")}</dd>
          </div>
        </dl>
      </div>

      <div className="box bg-surface p-6">
        <h3 className="text-lg font-medium">{t("admin.roles.title")}</h3>
        <p className="mt-2 max-w-3xl text-sm leading-relaxed text-ink/70">{t("admin.access.rolesBody")}</p>
        <Button className="mt-5" onClick={onOpenRoles}>{t("admin.access.openRoles")}</Button>
        <p className="mt-6 border-t border-ink/10 pt-4 text-xs leading-relaxed text-ink/55">
          {t("admin.access.assignmentOutlook")}
        </p>
      </div>
      <p className="max-w-3xl text-xs leading-relaxed text-ink/55">{t("admin.access.featureBoundary")}</p>
    </section>
  );
}
